<template>

  <v-container fluid class="px-0 order-info-route-info">

    <!----------------------------------------->
    <!-- Route Info (if assigned to a route) -->
    <!----------------------------------------->
    <template v-if="showRouteInfo">
      <!-- Containing Route Info -->
      <route-order-info class="page-content" :route="route" />

      <!-- Assigned Vehicle and Driver -->
      <route-vehicle-driver-summary class="page-content mt-4" :route="route" />

      <!-- Agent Info (when delivered) -->
      <!-- <order-agent-info
          v-if="order.order_status === 'DELIVERED' && !isCredit"
          class="mt-4 page-content"
          :order="order"
          :driver="driver" /> -->
    </template>

    <!------------------------------->
    <!-- Not yet scheduled message -->
    <!------------------------------->
    <v-container fluid class="px-10 py-12 page-content" v-else>
      <v-row>
        <v-col align="center" class="description-text">
          (Not yet scheduled)
        </v-col>
      </v-row>
    </v-container>

  </v-container>

</template>

<script>
import RouteVehicleDriverSummary from '@/components/routes/RouteVehicleDriverSummary'
import RouteOrderInfo from '@/components/routes/RouteOrderInfo'
// import OrderAgentInfo from '@/components/orders/OrderAgentInfo'

export default {
  name: 'OrderInfoRouteInfo',

  components: {
    RouteVehicleDriverSummary,
    RouteOrderInfo
    // OrderAgentInfo
  },

  props: {
    orderId: {
      type: String,
      default: null
    }
  },

  data () {
    return {
    }
  },

  computed: {
    order () {
      return this.$parent.order
    },
    isCredit () {
      return this.order.is_credit
    },
    route () {
      return this.$parent.route
    },
    driver () {
      return (this.route) ? this.route.driver : null
    },
    showRouteInfo () {
      return this.route && this.route.route_status !== 'CREATED'
    }
  }
}
</script>

<style>
  .order-info-route-info .description-text {
    color: #9e9e9e;
  }
</style>
